/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "16912f8843c1eba9da590c372ecac9ef29ae9f3a";
